import React from 'react';
import PropTypes from 'prop-types';

import IconChevronRight from '@spothero/icons/chevron-right';
import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, Icon} from '@spothero/ui';

const breadcrumbContainerStyleProps = {
    fontWeight: 'semibold',
    fontSize: 'xs',
    maxWidth: '22rem',
    spacing: 0,
    marginLeft: 'auto',
    paddingBottom: 2,
};

const breadcrumbIconStyleProps = {
    width: 2,
    height: 2,
    marginX: 1,
    color: 'gray.800',
};

const CustomBreadcrumbSeparator = () => (
    <Icon as={IconChevronRight} {...breadcrumbIconStyleProps} />
);

const Breadcrumbs = ({items, ...props}) => (
    <Breadcrumb
        separator={<CustomBreadcrumbSeparator />}
        {...breadcrumbContainerStyleProps}
        {...props}
    >
        {items
            .filter(({label}) => Boolean(label))
            .map(({link, label, isCurrentPage}) => (
                <BreadcrumbItem
                    key={label}
                    data-testid="breadcrumb-label"
                    color={
                        isCurrentPage && !link ? 'gray.600' : 'primary.default'
                    }
                >
                    <BreadcrumbLink
                        href={link}
                        isCurrentPage={isCurrentPage}
                        noOfLines={1}
                        maxW={72}
                        color="inherit"
                        _hover={{
                            color: 'inherit',
                        }}
                    >
                        {label}
                    </BreadcrumbLink>
                </BreadcrumbItem>
            ))}
    </Breadcrumb>
);

Breadcrumbs.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string,
            label: PropTypes.string.isRequired,
            isCurrentPage: PropTypes.bool.isRequired,
        })
    ),
};

export default Breadcrumbs;
